<script>
  import { onMount, createEventDispatcher } from "svelte"
  import Crop from "./innerCrop.svelte"
  import { loadImage } from "../../../../../../Publish/BulkUpload/Script/bulkUpload"
  import notify from "../../../../../../../Script/notify"
  const dispatch = createEventDispatcher()

  let canvas

  export let blobURL = ""
  export let autoCropDetails = ""

  const dimensions = {}

  let coordinate
  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  onMount(async () => {
    const imageForProcessing = await loadImage(blobURL)

    // console.log(imageForProcessing)

    const ctx = canvas.getContext("2d", { willReadFrequently: true })

    const width = imageForProcessing.naturalWidth
    const height = imageForProcessing.naturalHeight

    canvas.width = width
    canvas.height = height
    ctx.drawImage(imageForProcessing, 0, 0, width, height)

    dimensions.width = imageForProcessing.naturalWidth
    dimensions.height = imageForProcessing.naturalHeight
    // console.log(parseFloat(getComputedStyle(canvas).width), parseFloat(getComputedStyle(canvas).height))
    dimensions.clientHeight = parseFloat(getComputedStyle(canvas).height)
    dimensions.clientWidth = parseFloat(getComputedStyle(canvas).width)
  })

  const extractImage = async () => {
    try {
      // console.log({ coordinate })
      let splitCoordinates = coordinate.split(",")
      let blobObject = await cropCanvasToImage(canvas, Number(splitCoordinates[0]), Number(splitCoordinates[1]), Number(splitCoordinates[2]), Number(splitCoordinates[3]))
      dispatch("confirm", blobObject)
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Add Signer (Signature Crop area)\nEVENT: Error occured during cropped signature extraction"
      closeNotification = notify.danger(error, info)
    }
  }

  const cropCanvasToImage = (canvas, cropX, cropY, cropWidth, cropHeight) => {
    return new Promise(async (resolve, reject) => {
      try {
        // Get the 2D drawing context
        const ctx = canvas.getContext("2d")

        const MIN_WIDTH = 100
        const MIN_HEIGHT = 100

        // Calculate the aspect ratio of the cropped area
        const aspectRatio = cropWidth / cropHeight

        // console.log({ aspectRatio })

        // Determine the new dimensions that fit within the maximum dimensions
        let newWidth = cropWidth
        let newHeight = cropHeight

        // Step 1: Fit the height first within min/max limits
        if (newHeight < MIN_HEIGHT) {
          newHeight = MIN_HEIGHT
          newWidth = newHeight * aspectRatio
        }

        // Step 2: Adjust the width if it exceeds min limits
        if (newWidth < MIN_WIDTH) newWidth = MIN_WIDTH

        const newAspect = newHeight / newWidth
        if (newAspect < 0.15 || newAspect > 1.5) throw "Make sure to fine tune your crop area as it not fits within the dimensions."

        // let finalAspectRatio = newWidth / newHeight
        // const MAX_LIMIT = 400
        // if (finalAspectRatio < 1 || finalAspectRatio > 3) {
        //   if (newHeight > newWidth) {
        //     newHeight = MAX_LIMIT
        //     newWidth = (newHeight * cropWidth) / cropHeight

        //     if (newWidth < 100) newWidth = 100
        //   } else {
        //     newWidth = MAX_LIMIT
        //     newHeight = (newWidth * cropHeight) / cropWidth
        //     if (newHeight < 100) newHeight = 100
        //   }
        //   // throw "Make sure to fine tune your crop area as it not fits within the dimensions."
        // }

        console.log({ newWidth, newHeight })

        // Extract the cropped area
        const imageData = ctx.getImageData(cropX, cropY, cropWidth, cropHeight)

        // Create an intermediate canvas for the cropped area
        const intermediateCanvas = document.createElement("canvas")
        intermediateCanvas.width = cropWidth
        intermediateCanvas.height = cropHeight
        const intermediateCtx = intermediateCanvas.getContext("2d")

        // Place the imageData onto the intermediate canvas
        intermediateCtx.putImageData(imageData, 0, 0)

        // Create a new canvas for the resized image
        const croppedCanvas = document.createElement("canvas")
        croppedCanvas.width = newWidth
        croppedCanvas.height = newHeight
        const croppedCtx = croppedCanvas.getContext("2d")

        // Resize the image by drawing the intermediate canvas onto the resized canvas
        croppedCtx.drawImage(
          intermediateCanvas,
          0,
          0,
          cropWidth,
          cropHeight, // Source rectangle
          0,
          0,
          newWidth,
          newHeight // Destination rectangle
        )

        // console.log(croppedCanvas.width, croppedCanvas.height)

        // Convert the canvas to a blob
        let blobObject = await canvasToBlob(croppedCanvas)

        resolve(blobObject)
      } catch (error) {
        reject(error)
      }
    })
  }

  /**
   * Converts a canvas element to a Blob object.
   *
   * @returns {Promise<Blob>} A Promise that resolves with the generated Blob object.
   */
  const canvasToBlob = (canvas) => {
    /**
     * @typedef {Blob} Blob - Represents a binary large object (Blob) that can store binary data.
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Blob Blob}
     */

    return new Promise((resolve) => {
      /**
       * The `toBlob` method of the canvas element is used to convert it to a Blob.
       * @param {Blob} blob - The generated Blob object.
       */
      canvas.toBlob((blob) => {
        // Once the Blob is created, the Promise is resolved with the Blob object.
        resolve(blob)
      }, "image/png")
    })
  }
</script>

<div class="relative aspect-auto max-w-[75%]">
  <canvas bind:this={canvas} class="h-full max-h-[40vh] w-full max-w-[40vw] rounded-md" style="background:url('assets/img/grid.png')" />

  {#if Object.keys(dimensions).length}
    <Crop {dimensions} bind:coordinate {autoCropDetails} />
  {/if}
</div>

<div class="mt-3 flex w-full justify-center gap-3">
  <button on:click type="button" class="w-fit rounded-md bg-blue-500 py-2 px-4 text-sm font-bold text-white">
    <span>
      <i class="fa-solid fa-reply" />
    </span>
    &nbsp;&nbsp;Back
  </button>
  <button on:click={extractImage} type="button" class="w-fit rounded-md bg-violet-500 py-2 px-4 text-sm font-bold text-white">
    <span>
      <i class="fa-solid fa-crop" />
    </span>
    &nbsp;&nbsp;Crop Image
  </button>
</div>
